import React, { useRef, useState } from "react";
import { patchBidang } from "../../api";
import FormInput from "../../components/forms/Input";
import FormSelect from "../../components/forms/Select";
import LayoutModal, { NewSubmitButton } from "../../components/layouts/Modal";
import { saAlert } from "../../helpers";
import SmallButton from "../../components/forms/SmallButton";

const BidangEdit = (props) => {
  const { bidang, onFetchData } = props;
  const formRef = useRef();

  const [modal, setModal] = useState(false);

  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});

  const handleClose = () => {
    if (formRef.current) {
      formRef.current.reset();
    }
    setForm({});
    setErrors({});
    setModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    patchBidang(form.id, form)
      .then((res) => {
        if (res.data === "success") {
          onFetchData();
          handleClose();
          saAlert("success", "Berhasil ubah data bidang !");
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          setErrors(err.response.data.errors);
        }
      });
  };

  return (
    <>
      <SmallButton
        type='edit' 
        onClick={() => {
          setForm(bidang);
          setModal(true);
        }}
      />
      <LayoutModal modal={modal} title="Ubah Data Bidang" onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={formRef}>
          <FormInput
            label="Nama Bidang"
            name="nama"
            value={form.nama}
            onChange={(e) => {
              setForm((prevState) => {
                return { ...prevState, [e.target.name]: e.target.value };
              });
            }}
            error={errors.nama}
          />
          <FormSelect
            label="Kriteria"
            name="kriteria"
            value={form.kriteria}
            onChange={(e) => {
              setForm((prevState) => {
                return { ...prevState, [e.target.name]: e.target.value };
              });
            }}
            error={errors.kriteria}
          >
            <option value="">Pilih</option>
            <option value="1">Wajib</option>
            <option value="2">Pilihan</option>
          </FormSelect>
          <div className="row">
            <NewSubmitButton onClose={handleClose}/>
          </div>
        </form>
      </LayoutModal>
    </>
  );
};

export default BidangEdit;
